import type { Client } from '@src/clients/domain/Client';
import { Drawer } from '@src/common/components/Drawer';
import { PageLayout } from '@src/common/components/Page';
import { useToast } from '@src/common/hooks/useToast';
import type { Tractor } from '@src/tractor/domain/Tractor';
import { useCreateTractor } from '@src/tractor/hooks/useCreateTractor';
import { TractorPageForm } from '@src/tractor/TractorPageForm';
import { useTranslation } from 'react-i18next';

interface Props {
  client: Client;
  isOpen: boolean;
  onClose: () => void;
  onAdd: (newTractor: Tractor) => void;
}

export const AddTractorDrawer = ({ client, onClose, isOpen, onAdd }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const { createTractor, isLoading } = useCreateTractor({
    clientId: client.id,
    onSuccess: (newTractor) => {
      showSuccessToast(t('createTractor.success'));
      onAdd(newTractor);
    },
    onError: () => {
      showErrorToast(t('createTractor.error'));
    },
  });

  return (
    <Drawer open={isOpen} onClose={onClose} width="90vw">
      <PageLayout title={t('addTractor')}>
        <TractorPageForm
          onSubmit={createTractor}
          onCancel={onClose}
          isLoading={isLoading}
        />
      </PageLayout>
    </Drawer>
  );
};
